import { render, staticRenderFns } from "./right-sheet.vue?vue&type=template&id=2abd321e&scoped=true&"
import script from "./right-sheet.vue?vue&type=script&lang=js&"
export * from "./right-sheet.vue?vue&type=script&lang=js&"
import style0 from "./right-sheet.vue?vue&type=style&index=0&id=2abd321e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abd321e",
  null
  
)

export default component.exports